import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  radio: {
    marginBottom: theme.spacing(2),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  section: {
    marginTop: theme.spacing(2),
  },
}));

export default useStyles;
